// colors.ts
export const COLORS = {
    statusPending: "#EECC15",
    statusPaymentPending: "#152259",
    primary: "#B89338",
    orange: "#FE4819",
    background: "#F3EFE6",
    card: "#E3DFD6",
    darkGray: "#111111",
    black: "#000000",
    gray: "#333333",
    lightGray: "#E6E6EA",
    arrowGray: "#AAAAAA",
    white: "#FFFFFF",
    border: "#DCDCDC",
    folderSearch: "#1E1E1E",
    folderSearchBorder: "#3C3C3C",
    placeholder: "#999999",
} as const;





// background: #E3DFD6; // card color
// background: #F3EFE6; //background color

// background: #B89338; // primary yellow
// background: #FE4819; // orange